import ConditionsComponent from "@builder/components/app/Conditions";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import "./style.scss";

const Conditions: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    return (
        <SidebarCollapse styles={{ padding: 0 }} title="Conditions" parent={parent}>
            <ConditionsComponent />
        </SidebarCollapse>
    );
};

export default Conditions;
